import React from 'react'
import ReactDOM from 'react-dom'
import { Transition } from 'react-transition-group'
import PreviewButton from '../components/PreviewButton'
import styled from 'styled-components'
import Brightness from '../scripts/Brightness'

import SiteIcons from '../assets/SiteIcons'

import { NavLink } from 'react-router-dom'

class CoursePopup extends React.Component {

  stopBodyScrolling (bool) {
    if (bool === true) {
        let theApp = document.getElementById('contentContainer')
        theApp.addEventListener("touchmove", this.freezeVp, false);
        document.body.style.overflow = 'hidden'
    } else {
        let theApp = document.getElementById('contentContainer')
        theApp.removeEventListener("touchmove", this.freezeVp, false);
        document.body.style.overflow = 'inherit'
    }
  }

  freezeVp(e) {
    e.preventDefault()
  }

  componentDidMount() {
    const ThePopup = this.refs.popup
    this.stopBodyScrolling(true)

    setTimeout(function(){
      ReactDOM.findDOMNode(ThePopup).classList.add('show')
    }, 250)
  }

  componentWillUnmount() {
    const ThePopup = this.refs.popup
    ReactDOM.findDOMNode(ThePopup).classList.remove('show')
    this.stopBodyScrolling(false)
  }

  render () {

    const NavChange = () => {
      this.props.navChange()
    }

    let category = this.props.category

    // Get the category from the URL
    let catText = 'category'

    let mobileClass

    if ( this.props.mobile === true ) {
      mobileClass = ' mobile'
    } else {
      mobileClass = ''
    }


    const CloseLinkStyles = styled.div`
      a {
        color: rgb(45, 45, 45);

        &:hover {
          color: ${this.props.themeStyles.mainColor};

          svg {
            * {
              fill: ${this.props.themeStyles.mainColor};
            }
          }
        }
      }
    `

    const MyCourse = this.props.jsonData.map((course) => {

      if (this.props.courseID === course.entry_id) {

        const AddToReport = course.add_to_report.split('|')
        const Languages = ['English']

        if (AddToReport.includes('Spanish')) {
          Languages.push('Spanish')
        }

        if (AddToReport.includes('French')) {
          Languages.push('French')
        }

        let bgImageStyle

        if (course.screenshot != undefined) {
          bgImageStyle = {
            backgroundImage: 'url(https://assets.lmscourses.com/lesson-screenshots/' + course.screenshot + ')'
          }
        }

        return (
          <div className="popupContents" key={course.entry_id}>
            <div className="detailsContainer">

              <div className="description">
                <h1>{course.en_us_lesson_name}</h1>

                <div className="courseSpecDetails">
                  <span className="duration">
                    <SiteIcons icon="time" />
                    <span>{course.lesson_hours}:{course.lesson_minutes}</span>
                  </span>
                  <span className="languages">
                    <SiteIcons icon="languages" />
                    {Languages.map((lan, idx) => {

                      let langComma = ''
                      let langLength = Languages.length - 1;

                      if ( idx !== langLength) {
                        langComma = ','
                      }

                      return <span key={idx}>{lan}{langComma}</span>
                    })}
                  </span>
                </div>
                <p>{course.lesson_description}</p>
              </div>
            </div>
            <PreviewButton
              localURL={this.props.localURL}
              loggedInInfo={this.props.loggedInInfo}
              courseURL={course.url_title}
              courseName={course.en_us_lesson_name}
              languages={Languages}
              supported={this.props.supported}
              themeStyles={this.props.themeStyles}
              popup={true}
             />
          </div>
        )
      }
    })

    if ( category === 'all-courses' ) {
      category = 'all-courses'
    }

    return (
      <div ref="popup" className={"popupContainer" + mobileClass}>
        <div className="popupScroll">
          <div className="popup">
            <CloseLinkStyles className="closeContainer">
              <NavLink className="closeLink" to={"/courses/" + category}>
                Close<SiteIcons icon="close" />
              </NavLink>
            </CloseLinkStyles>
              {MyCourse}
          </div>
        </div>
        <span className="popupBackground"></span>
      </div>
    )
  }

}

export default CoursePopup
